import { Page } from "../../commons/layout/Page.js";
import { PageContainer } from "../../commons/layout/PageContainer.js";

export const WebShopCms = () => {
  return (
    <Page>
      <PageContainer $fullHeight $noPadding>
        <iframe
          style={{
            width: "100%",
            height: "100%",
            border: 0,
            padding: 0,
            margin: 0,
          }}
          src={import.meta.env.VITE_CMS_URL}
        ></iframe>
      </PageContainer>
    </Page>
  );
};
